import React, { FC } from 'react';
import { Title } from '@investoro/core';
import { useUser } from 'store/User/Context';
import styled from 'styled-components';

import { ArchivedLabel, LabelsContainer as BaseLabelsContainer, OfferLabel, StatusLabel } from 'components/common/Card/common/OfferLabels';
import TitleWithSecondValueAndTooltip from 'components/common/TitleWithSecondValueAndTooltip';

const Container = styled.div`
    position: relative;
    display: grid;
    grid-area: ${(props) => props.isUpperLabel ? '2 / 1 / 2 / right' : '1 / 1 / 1 / right'};
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
    gap: 5px;
`;

const LabelsContainer = styled(BaseLabelsContainer)`
    grid-area: 1 / 1;
`;

const ActivationLabel = styled.span`
    --font-size-body: var(--font-size-body-3);

    padding: 5px 10px;
    background: ${(props) => props.isDarkMode
        ? props.isActiveStatus ? 'var(--label-color-active)' : 'var(--label-color-inactive)'
        : props.isActiveStatus ? 'var(--label-color-active)' : 'var(--label-color-inactive)'};
    
    ${(props) => props.isDarkMode ? '#FFFF' : 'color: var(--color-primary)'};
    border-radius: 5px;
    height: min-content;  
`;

const PreTitle = styled.div`
    line-height: 20px;
    grid-area: 1;
`;

const PreTitileWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: fit-content;
    align-items: flex-start;
`;

interface TopProperties {
    title: string;
    preTitle?: string;
    additionalPreTitleString?: string;
    ratingScore?: number | null; // jest zawsze zwracana w module sale i rent, ale nie jest przekazywana w modułach, które nie mają ratingu
    scorePrecision?: number | null; // jak wyżej
    lowestPriceLabel?: boolean;
    privateOfferLabel?: boolean;
    archivedLabel?: boolean;
    activationStatusTextLabel?: string;
    activationStatus?: boolean;
    withPrediction?: boolean;
    hasPredictionRole?: boolean;
    isDuplicate?: boolean;
}

const Top: FC<TopProperties> = ({
    preTitle,
    lowestPriceLabel,
    activationStatusTextLabel,
    activationStatus,
    privateOfferLabel,
    archivedLabel,
    additionalPreTitleString,
    withPrediction,
    hasPredictionRole,
    isDuplicate,
    title
}) => {
    const { user } = useUser();

    return (
        <>
            <LabelsContainer>
                {archivedLabel && <ArchivedLabel>Oferta nieaktualna</ArchivedLabel>}
                {isDuplicate !== undefined && <StatusLabel isDuplicate={isDuplicate}>{isDuplicate ? 'Duplikat' : 'Oryginał'}</StatusLabel>}
                {lowestPriceLabel && <OfferLabel>Duplikat z niższą ceną</OfferLabel>}
                {privateOfferLabel && <OfferLabel>Duplikat od os. prywatnej</OfferLabel>}
            </LabelsContainer>
            <Container isUpperLabel={lowestPriceLabel || privateOfferLabel || archivedLabel}>
                <PreTitileWrapper>
                    {activationStatusTextLabel && <ActivationLabel isDarkMode={user.isDarkMode} isActiveStatus={activationStatus}>{activationStatusTextLabel}</ActivationLabel>}
                    {!withPrediction && preTitle && !additionalPreTitleString && <PreTitle>{preTitle}</PreTitle>}
                    {withPrediction && preTitle || additionalPreTitleString ? <TitleWithSecondValueAndTooltip title={preTitle} additionalTitle={additionalPreTitleString} hasPredictionRole={hasPredictionRole}/> : null}
                    <Title>{title}</Title>
                </PreTitileWrapper>
            </Container>
        </>
    );
};

export default Top;
